/* @ngInject */
function userArtsService ($q, $rootScope, ArtCollectionsService, ToastService) {
  const sidebar = {
    items: []
  }

  const service = {
    getSideBarItems,
    getCompanyFeatures
  }

  return service

  /**
   * Get sidebar items.
   */
  async function getSideBarItems () {
    if (sidebar.items.length > 0) return sidebar.items

    const promises = [
      ArtCollectionsService.getHighlightedCollections({}),
      ArtCollectionsService.getArtSections({})
    ]

    try {
      const [highlightedCollections, sections] = await $q.all(promises)
      _normalizeSectionsSidebar(sections?.rows ?? [])
      _normalizeHighlightedCollectionsSidebar(highlightedCollections?.rows ?? [])
    } catch (error) {
      ToastService.defaultErrorToast()
      console.error({ error })
    }

    return sidebar.items ?? []
  }

  /**
   * Get some company features.
   */
  async function getCompanyFeatures () {
    const { features } = await $rootScope.getCompanyFeaturesAndAddons()
    const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
    return {
      artsCustomization: {
        access: !!features[customizableArtsSlug]
      }
    }
  }

  function _normalizeSectionsSidebar (sections = []) {
    const rows = sections?.map(section => ({ id: section.id, title: section.title })) ?? []
    if (!rows?.length) return
    sidebar.items = [
      ...(sidebar.items ?? []),
      { name: 'userArts.sections.title', row: rows }
    ]
  }

  function _normalizeHighlightedCollectionsSidebar (highlightedCollections = []) {
    const rows = highlightedCollections?.map(collection => ({ id: collection.id, title: collection.title })) ?? []
    if (!rows?.length) return
    sidebar.items = [
      {
        name: 'userArts.highlightedCollections.title', row: rows
      },
      ...(sidebar.items ?? [])
    ]
  }
}

export { userArtsService }
